import { InstructionStep } from './InstructionStep';

interface Props {
  images: string[];
  instructions: string[][];
}

export const Instructions = ({ images, instructions }: Props) => (
  <>
    {instructions.map((textParts, index) => {
      // Filter out empty strings and undefined/null values from textParts
      const filteredTextParts = textParts.filter(
        part => part && typeof part === 'string' && part.trim() !== ''
      );
      if (filteredTextParts.length === 0) {
        return null;
      }
      return (
        <InstructionStep
          key={index}
          textParts={filteredTextParts}
          imageSrc={images[index]}
        />
      );
    })}
  </>
);
